import { isoDateString } from '@clockwise/shared';
import { z } from 'zod';

/**
 * One row of a user's cost history. `effectiveFrom` and `effectiveTo`
 * are calendar dates (YYYY-MM-DD); `effectiveTo` is null on the current
 * open-ended period. `costPerHour` round-trips as a string from the API
 * to preserve numeric precision — the FE coerces with Number() at the
 * boundary.
 */
export const UserEmployeeCostSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  userId: z.string().uuid(),
  effectiveFrom: z.string(),
  effectiveTo: z.string().nullable(),
  costPerHour: z.string(),
  createdBy: z.string().uuid().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type UserEmployeeCost = z.infer<typeof UserEmployeeCostSchema>;

/**
 * Body for "set the cost for this user as of this date." The service
 * handles the clipping (closing the prior open period at the new
 * effectiveFrom, splitting any range that contains it). Callers send a
 * single statement of intent.
 */
export const SetUserEmployeeCostInput = z.object({
  userId: z.string().uuid(),
  effectiveFrom: isoDateString(),
  costPerHour: z.number().nonnegative(),
});
export type SetUserEmployeeCostInput = z.infer<typeof SetUserEmployeeCostInput>;

export interface ListUserEmployeeCostsQuery {
  userId: string;
  /** When set, the server returns only the row in effect on this date. */
  asOf?: string;
}
